<template>
  <div class="activityEmailControlsWrapper">
    <div v-if="nofetch">
      <ActivityEmailControls
        :debug="debug"
        :title="''"
        :groupID="emailSettings.group_id"
        :userID="emailSettings.user_id"
        :aggregate="emailSettings.aggregate"
        :consent="emailSettings.consent"
        @groupNotificationsSettingsChanged="updateEmailSettings"
      ></ActivityEmailControls>
    </div>
    <div v-else>
      <ActivityEmailControls
      v-if="emailSettings && group && user && !loading"
      :title="''"
      :debug="debug"
      :groupID="group.id"
      :userID="user.id"
      :aggregate="emailSettings.aggregate"
      :consent="emailSettings.consent"
      @groupNotificationsSettingsChanged="updateEmailSettings"
    ></ActivityEmailControls>
    <p v-else>Please wait...</p>
    </div>
  </div>
</template>
<script>
import ActivityEmailControls from '@/components/Widgets/ActivityEmailControls';
import ActivityEmailService from "@/services/ActivityEmailService";
export default {
  components: { ActivityEmailControls },
  props: [
    'debug',
    'group',
    'user',
    'nofetch',
    'settings'
  ],
  data() {
    return {
      emailSettings: {},
      loading: false
    };
  },
  watch: {
    settings: {
      handler(newValue) {
        if (this.nofetch) {
          this.loading = false;
          this.emailSettings = newValue;
        }
      },
      // force eager callback execution
      immediate: true,
      deep: true
    },
    group: {
      handler(newValue) {
        if (this.group && this.group.id) {
          this.loading = true;
          this.getEmailSettings(this.group.id);
        }
      },
      // force eager callback execution
      immediate: true,
      deep: true
    },
    user: {
      handler(newValue) {
        if (this.group && this.group.id) {
          this.loading = true;
          this.getEmailSettings(this.group.id);
        }
      },
      // force eager callback execution
      immediate: true,
      deep: true
    }
  },
  methods: {
    getEmailSettings(groupId) {
      if (this.nofetch) {
        // No fetch.
        this.loading = false;
        return false;
      }
      return ActivityEmailService.getEmailSettings(
        groupId
      ).then(
        response => {
          this.emailSettings = response.body;
          this.loading = false;
        },
        response => {
          console.error("[error] loading email settings");
          this.loading = false;
        }
      );
    },
    updateEmailSettings(msg, groupId, userId, consent, aggregate) {
      if (this.emailSettings && (this.emailSettings.consent !== consent || this.emailSettings.aggregate !== aggregate)) {
        return ActivityEmailService.updateEmailSettings(
          groupId, userId, consent, aggregate
        ).then(
          response => {
            this.emailSettings = response.body;
            this.$store.commit("updateMessage", {
              message: "Your email preferences have been updated.",
              snackbar: true
            });
          },
          response => {
            console.error("[error] loading email settings");
          }
        );
      }
    }
  }
};
</script>
